<template>
  <Dialog :visible.sync="showConsultaNotaNacional" :modal="true" :closable="false">
    <h1 class="titulo-header">
      Consulta de Notas ADN Nota Nacional para importação
      <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
        @click="showConsultaNotaNacional = false" />
    </h1><br />
    <div class="scrolable-dialog">
      <div class="row">
        <div class="col-md-4 col-lg-2 mb-3">
          <label style="font-weight: bold; font-size: 12px">Competência:</label>
          <InputText v-model="competencia" disabled />
        </div>
      </div>
      <div id="topo" class="row">
        <template>
          <Checkbox v-model="checkTodos" :binary="true" @change="selecionarTodos()" />
          <span style="margin-bottom: 10px; padding-left: 5px; font-weight: bold; font-size: 12px">Selecionar Todos</span>
        </template>
        <DataTable :value="notasNacionaisList" :paginator="true" :rows="10" class="p-datatable-responsive"
          :autoLayout="true" :filters="filtersModel" :key="0">
          <Column headerStyle="width: 3%" field="selecionado" header>
            <template #body="slotProps">
              <Checkbox v-model="slotProps.data.selecionado" :binary="true" :disabled="isRowDisabled(slotProps.data)" />
            </template>
          </Column>
          <Column headerStyle="width: 10%" field="descricaoEvento" header="Possui Evento?">
            <template #body="slotProps">
              <div :class="lineClass(slotProps.data)">
                {{ slotProps.data.descricaoEventoFormatado }}
              </div>
            </template>
            <template #filter>
              <InputText type="text" v-model="filtersModel['descricaoEvento']" class="p-column-filter"
                placeholder="Iniciando com" style="width: 10em" />
            </template>
          </Column>
          <Column headerStyle="width: 10%" field="numeroDps" header="Número DPS">
            <template #body="slotProps">
              <div :class="lineClass(slotProps.data)">
                {{ slotProps.data.numeroDps }}
              </div>
            </template>
            <template #filter>
              <InputText type="text" v-model="filtersModel['numeroDps']" class="p-column-filter"
                placeholder="Iniciando com" style="width: 10em" />
            </template>
          </Column>
          <Column headerStyle="width: 10%" field="numeroNfse" header="Número NFSe">
            <template #body="slotProps">
              <div :class="lineClass(slotProps.data)">
                {{ slotProps.data.numeroNfse }}
              </div>
            </template>
            <template #filter>
              <InputText type="text" v-model="filtersModel['numeroNfse']" class="p-column-filter"
                placeholder="Iniciando com" style="width: 10em" />
            </template>
          </Column>
          <Column headerStyle="width: 10%" field="chaveAcesso" header="Chave Acesso Nacional">
            <template #body="slotProps">
              <div :class="lineClass(slotProps.data)">
                {{ slotProps.data.chaveAcesso }}
              </div>
            </template>
            <template #filter>
              <InputText type="text" v-model="filtersModel['chaveAcesso']" class="p-column-filter"
                placeholder="Iniciando com" style="width: 10em" />
            </template>
          </Column>
          <Column headerStyle="width: 10%" field="dataFatoGeradorFormatada" header="Competência">
            <template #body="slotProps">
              <div :class="lineClass(slotProps.data)">
                {{ slotProps.data.dataFatoGeradorFormatada }}
              </div>
            </template>
            <template #filter>
              <InputText type="text" v-model="filtersModel['dataFatoGeradorFormatada']" class="p-column-filter"
                placeholder="Iniciando com" style="width: 10em" />
            </template>
          </Column>
          <Column headerStyle="width: 10%" field="tipoRecolhimentoFormatado" header="Recolhimento">
            <template #body="slotProps">
              <div :class="lineClass(slotProps.data)">
                {{ slotProps.data.tipoRecolhimentoFormatado }}
              </div>
            </template>
            <template #filter>
              <InputText type="text" v-model="filtersModel['tipoRecolhimentoFormatado']" class="p-column-filter"
                placeholder="Iniciando com" style="width: 10em" />
            </template>
          </Column>
          <Column headerStyle="width: 10%" field="detailPrestador" filter filterMatchMode="contains" header="Prestador">
            <template #body="slotProps">
              <div :class="lineClass(slotProps.data)">
                {{ slotProps.data.detailPrestador }}
              </div>
            </template>
            <template #filter>
              <InputText type="text" v-model="filtersModel['detailPrestador']" class="p-column-filter"
                placeholder="Contém" style="width: 18em" />
            </template>
          </Column>
          <Column headerStyle="width: 10%" field="codigoServicoNacional" header="Serviço">
            <template #body="slotProps">
              <div :class="lineClass(slotProps.data)">
                {{ slotProps.data.codigoServicoNacional }}
              </div>
            </template>
            <template #filter>
              <InputText type="text" v-model="filtersModel['codigoServicoNacional']" class="p-column-filter"
                placeholder="Iniciando com" style="width: 10em" />
            </template>
          </Column>
          <Column headerStyle="width: 10%" field="valorFormatado" header="Valor">
            <template #body="slotProps">
              <div :class="lineClass(slotProps.data)">
                {{ slotProps.data.valorFormatado }}
              </div>
            </template>
            <template #filter>
              <InputText type="text" v-model="filtersModel['valorFormatado']" class="p-column-filter"
                placeholder="Iniciando com" style="width: 10em" />
            </template>
          </Column>
          <Column headerStyle="width: 10%" field="aliquotaFormatada" header="Alíquota">
            <template #body="slotProps">
              <div :class="lineClass(slotProps.data)">
                {{ slotProps.data.aliquotaFormatada }}
              </div>
            </template>
            <template #filter>
              <InputText type="text" v-model="filtersModel['aliquotaFormatada']" class="p-column-filter"
                placeholder="Iniciando com" style="width: 10em" />
            </template>
          </Column>
          <Column headerStyle="width: 10%" field="valorIssFormatado" header="Valor Iss">
            <template #body="slotProps">
              <div :class="lineClass(slotProps.data)">
                {{ slotProps.data.valorIssFormatado }}
              </div>
            </template>
            <template #filter>
              <InputText type="text" v-model="filtersModel['valorIssFormatado']" class="p-column-filter"
                placeholder="Iniciando com" style="width: 10em" />
            </template>
          </Column>
        </DataTable>
      </div>
    </div>

    <hr />

    <div class="row">
      <div>
        <Button @click="ocultarDialogNotas()" type="button" label="Fechar" class="p-button-primary mr-2 p-button-danger"
          icon="pi pi-times" />
        <Button @click="importar()" label="Importar" type="button" class="p-button-primary mr-2 p-button-success"
          icon="pi pi-file" :disabled="loading" />
      </div>
    </div>

  </Dialog>
</template>

<script>
import LoginService from "../../services/acesso/login.service";
import NotaFiscalNacionalService from "../../services/nfse/notafiscalnacional.service";

export default {
  name: "ConsultaNotaNacional",

  data() {
    return {
      currentUser: null,
      checkTodos: false,
      showConsultaNotaNacional: false,
      messageList: null,
      notasNacionaisList: [],
      competencia: null,
      filtersModel: {}
    };
  },

  created() {
    this.currentUser = LoginService.currentUserValue;
    this.$root.$on("declaracao:consultaNotasNacionais", (idCliente, idContribuinte, ano, mes, competencia) => {
      this.checkTodos = false;
      this.competencia = competencia
      this.pesquisar(idCliente, idContribuinte, ano, mes);
    });

  },

  methods: {
    isRowDisabled(data) {
      return data.descricaoEvento != null && data.descricaoEvento.trim() !== "";
    },
    selecionarTodos() {
      if (this.checkTodos) {
        this.notasNacionaisList.forEach((value) => {
          if (!this.isRowDisabled(value)) {
            value.selecionado = true;
          }
        });
      } else {
        this.notasNacionaisList.forEach((value) => {
          if (!this.isRowDisabled(value)) {
            value.selecionado = false;
          }
        });
      }
    },
    lineClass(data) {
      return data.status === "Cancelada" ||
        data.status === "Retificada" ||
        data.status === "Encerrada"
        ? "white-line"
        : null;
    },
    pesquisar(idCliente, idContribuinte, ano, mes) {
      this.notasNacionaisList = [];
      NotaFiscalNacionalService.findAllNotasParaConversaoDaps(
        idCliente, idContribuinte, ano, mes
      ).then(
        response => {
          this.notasNacionaisList = response;
        },
        error => {
          let errorMessage = "Houve um problema ao listar as Notas!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      ).then(() => {
        this.$parent.processando(false);
        this.showConsultaNotaNacional = true;
      });

    },
    importar() {
      if (!this.notasNacionaisList || this.notasNacionaisList.length <= 0) {
        this.$root.$emit(
          "alert:warn",
          "Selecione ao menos uma nota para realizar a Importação!"
        );
        return;
      } else {
        let checked = false;
        this.notasNacionaisList.forEach(function (value) {
          if (value.selecionado) {
            checked = true;
            return;
          }
        });
        if (!checked) {
          this.$root.$emit(
            "alert:warn",
            "Selecione ao menos uma nota para realizar a Importação!"
          );
        } else {
          this.$parent.processando(true);
          let listNotasSelecionadas = [];
          this.notasNacionaisList.forEach(function (value) {
            if (value.selecionado) {
              listNotasSelecionadas.push(value);
            }
          });

          NotaFiscalNacionalService.importarNotaNacionalDaps(
            this.currentUser.usuario.idCliente,
            this.currentUser.usuario.idUsuario,
            this.currentUser.contribuinte.idContribuinte,
            listNotasSelecionadas
          )
            .then(
              (response) => {
                console.log(response);
                this.$parent.pesquisar();
                this.$root.$emit("alert:success", "Importação realizada com sucesso!");
              },
              (error) => {
                console.log(error);
                let mensagemErro = error.response.data;

                if (Array.isArray(mensagemErro)) {
                  mensagemErro = mensagemErro.join("\n");
                }

                this.$root.$emit("alert:error", mensagemErro);
              }
            )
            .then(() => {
              this.$parent.processando(false);
              this.showConsultaNotaNacional = false;
            });
        }
      }
    },
    ocultarDialogNotas() {
      this.showConsultaNotaNacional = false;
    },

  },

  computed: {
    loading() {
      return this.$parent.loading;
    },
  },
};
</script>

<style scoped>
.scrolable-dialog {
  padding-right: 25px;
  width: 90vw;
  max-height: 65vh;
  overflow-y: auto;
  overflow-x: hidden;
}

textarea {
  width: 100%;
  border-radius: 12px;
}
</style>